import { ContentLoading } from "../components/ContentLoading";
import { Skeleton } from "../components/ui/skeleton";

export function DocsPageLoading({ label = "Loading page…" }: { label?: string }) {
  return (
    <div className="min-w-0">
      <div aria-hidden="true" className="flex h-12 items-center justify-between border-b px-4">
        <Skeleton className="h-3 w-28" />
        <Skeleton className="h-6 w-20" />
      </div>
      <ContentLoading
        label={label}
        variant="document"
        className="mx-auto min-h-96 max-w-[860px] px-5 pt-7 pb-16 sm:px-12 sm:pt-9"
      />
    </div>
  );
}

export function DocsWorkspaceLoading() {
  return (
    <section className="min-w-0 bg-card" aria-labelledby="docs-loading-title">
      <header className="flex h-12 items-center border-b px-4">
        <h1 id="docs-loading-title" className="text-lg font-semibold">
          Docs
        </h1>
      </header>
      <div className="grid min-w-0 lg:grid-cols-[224px_minmax(0,1fr)]">
        <div
          aria-hidden="true"
          className="hidden min-h-[calc(100dvh-3rem)] space-y-5 border-r p-4 lg:block"
        >
          <Skeleton className="h-3 w-16" />
          <Skeleton className="h-5 w-3/4" />
          <Skeleton className="ml-4 h-4 w-2/3" />
          <Skeleton className="ml-4 h-4 w-1/2" />
        </div>
        <DocsPageLoading label="Loading documentation…" />
      </div>
    </section>
  );
}
